<template>
  <div class="d-flex border-bottom">
    <b-container fluid class="p-0">
      <div class="d-flex align-items-center justify-content-between">
        <div class="w-50 me-5">
          <div class="mb-2 mx-1"><span>Start time</span></div>
          <b-row no-gutters>
            <b-col cols="6" class="pr-3">
              <v-autocomplete
                :label="$t('hours')"
                v-model="rule.startHour"
                :items="hours"
                item-text="text"
                item-value="text"
                dense
                outlined
              />
            </b-col>
            <b-col cols="6" class="pr-3">
              <v-autocomplete
                v-model="rule.startMinute"
                :label="$t('minutes')"
                :items="minutes"
                item-text="text"
                item-value="text"
                dense
                outlined
                :error-messages="ruleStartMinuteErrors"
                @blur="$v.rule.startMinute.$touch()"
              />
            </b-col>
          </b-row>
        </div>

        <div class="w-50">
          <div class="mb-2 mx-1"><span>End time</span></div>
          <b-row no-gutters>
            <b-col cols="6" class="pr-3">
              <v-autocomplete
                :label="$t('hours')"
                v-model="rule.endHour"
                :items="hours"
                item-text="text"
                item-value="text"
                dense
                outlined
              />
            </b-col>
            <b-col cols="6" class="pr-3">
              <v-autocomplete
                v-model="rule.endMinute"
                :label="$t('minutes')"
                :items="minutes"
                item-text="text"
                item-value="text"
                dense
                outlined
                :error-messages="ruleEndMinuteErrors"
                @blur="$v.rule.endMinute.$touch()"
              />
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
    <div class="max-h-65 mt-1 d-flex align-items-center justify-center">
      <button
        class="h-40px w-40px btn btn-sm btn-icon btn-light-info btn-hover-light"
        @click="deleteRule"
      >
        <span class="svg-icon">
          <v-icon size="18">mdi-delete</v-icon>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { SET_ACTION_NOT_VALID } from "@/core/services/store/omsRules.module";

export default {
  name: "Action",
  mixins: [validationMixin],
  validations: {
    rule: {
      startHour: { required },
      endHour: { required },
      startMinute: { required },
      endMinute: { required },
    },
  },
  props: {
    rule: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
    },
    operators: {
      required: true,
      type: Array,
    },
  },
  computed: {
    // Generate hours array: 08 to 18
    hours: function () {
      return Array.from({ length: 11 }, (_, i) => {
        const value = i + 8; // start from 8
        return {
          index: value,
          text: value.toString().padStart(2, "0"),
        };
      });
    },
    minutes: function () {
      // Generate minutes array: 00, 15, 30, 45
      return Array.from({ length: 4 }, (_, i) => {
        const value = i * 15;
        return {
          index: value,
          text: value.toString().padStart(2, "0"),
        };
      });
    },
    ruleStartMinuteErrors: function () {
      return this.handleFormValidation("startMinute", this, "rule");
    },
    ruleEndMinuteErrors: function () {
      return this.handleFormValidation("endMinute", this, "rule");
    },
  },
  methods: {
    handleFormValidation(fieldName, vueObj, dataName = "formData") {
      const errors = [];
      if (!vueObj.$v[`${dataName}`][fieldName].$dirty) return errors;
      if ("required" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      if ("maxValue" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].maxValue &&
          errors.push("This field must be greater than 0");
      }
      if ("url" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].url &&
          errors.push(this.$t("validation_this_url_is_invalid"));
      }
      if ("numeric" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].numeric &&
          errors.push(this.$t("validation_this_must_be_a_number"));
      }
      if ("email" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].email &&
          errors.push(this.$t("validation_this_email_address_is_invalid"));
      }
      return errors;
    },

    deleteRule: function () {
      const self = this;
      const parentRules = self.$parent.currentQuery;
      parentRules.splice(parentRules.indexOf(self.rule), 1);
    },
  },
  watch: {
    rule: {
      handler() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$store.commit(SET_ACTION_NOT_VALID, true);
        } else {
          this.$store.commit(SET_ACTION_NOT_VALID, false);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.border-bottom:last-of-type {
  border-bottom: none !important;
}
</style>
